import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.readOnly ? [_vm.isEmpty ? [_vm._v("No data")] : [_c("div", [_vm._v(_vm._s(_vm.baseModel.street) + ",")]), _vm.baseModel.address_line_2 ? _c("div", [_vm._v(_vm._s(_vm.baseModel.address_line_2) + ",")]) : _vm._e(), _vm.baseModel.address_line_3 ? _c("div", [_vm._v(_vm._s(_vm.baseModel.address_line_3) + ",")]) : _vm._e(), _vm.baseModel.address_complement ? _c("div", [_vm._v(_vm._s(_vm.baseModel.address_complement) + ",")]) : _vm._e(), _c("div", [_vm._v(_vm._s(_vm.baseModel.zip) + " " + _vm._s(_vm.baseModel.city))]), _c("div", [_vm.baseModel.state != null && typeof _vm.baseModel.state.state_label != "undefined" && _vm.baseModel.state.state_label != null ? [_vm._v(" " + _vm._s(_vm.baseModel.state.state_label) + ", ")] : _vm._e(), _vm._v(" " + _vm._s(_vm.baseModel.country.printable_name) + " ")], 2), _vm.showDeliveryInstructions && !String.isNullOrEmpty(_vm.baseModel.deliveryInstructions) ? _c("div", {
    staticClass: "mt-2 text-smaller text-italic"
  }, [_vm._v(" " + _vm._s(_vm.baseModel.deliveryInstructions) + " ")]) : _vm._e()]] : [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      disabled: _vm.disabled,
      label: "Road",
      items: _vm.addressSuggestions,
      loading: _vm.loadingAddressSuggestions,
      "search-input": _vm.searchInput,
      placeholder: "1 Faubourg Saint-Honoré",
      rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
      "hide-details": "auto",
      clearable: "",
      "item-text": "place_name",
      "no-filter": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.searchInput = $event;
      },
      change: _vm.onAddressSelected
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.place_name))])], 1)];
      }
    }, {
      key: "append",
      fn: function fn() {
        return [_c(VIcon, {
          staticClass: "cursor--pointer",
          attrs: {
            disabled: _vm.disabled || _vm.loadingCurrentLocation
          },
          on: {
            click: _vm.useCurrentLocation
          }
        }, [_vm._v(" " + _vm._s(_vm.loadingCurrentLocation ? "mdi-loading mdi-spin" : "mdi-crosshairs-gps") + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.baseModel.street,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "street", $$v);
      },
      expression: "baseModel.street"
    }
  }), _vm.typeDisplayError != "rules" && _vm.errorLabels.street.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.street) + " ")]) : _vm._e()], 1), _c("div", [_vm.baseModel.address_line_2 || _vm.baseModel.street && !_vm.disabled ? _c(VTextField, {
    attrs: {
      disabled: _vm.disabled,
      label: "Address line 2",
      placeholder: "Apartment 123",
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.address_line_2,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "address_line_2", $$v);
      },
      expression: "baseModel.address_line_2"
    }
  }) : _vm._e()], 1), _c("div", [_vm.baseModel.address_line_3 || _vm.baseModel.address_line_2 && !_vm.disabled ? _c(VTextField, {
    attrs: {
      disabled: _vm.disabled,
      label: "Address line 3",
      placeholder: "Unit 12",
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.address_line_3,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "address_line_3", $$v);
      },
      expression: "baseModel.address_line_3"
    }
  }) : _vm._e()], 1), _c("div", [_vm.baseModel.address_complement || _vm.baseModel.address_line_3 && !_vm.disabled ? _c(VTextField, {
    attrs: {
      disabled: _vm.disabled,
      label: "Address complement",
      placeholder: "Last house on the left",
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.address_complement,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "address_complement", $$v);
      },
      expression: "baseModel.address_complement"
    }
  }) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      disabled: _vm.disabled,
      label: "Zip code",
      placeholder: "75001",
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "zip", $$v);
      },
      expression: "baseModel.zip"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      disabled: _vm.disabled,
      label: "City",
      placeholder: "Paris",
      rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.city,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "city", $$v);
      },
      expression: "baseModel.city"
    }
  }), _vm.typeDisplayError != "rules" && _vm.errorLabels.city.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.city) + " ")]) : _vm._e()], 1), _vm.countryTooltipMessage ? [_c(VTooltip, {
    attrs: {
      top: "",
      "max-width": "15rem"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            items: _vm.listCountries,
            "hide-no-data": "",
            "hide-selected": "",
            "item-text": "printable_name",
            "return-object": "",
            label: "Country",
            placeholder: "Country",
            disabled: _vm.disabledCountry || _vm.disabled,
            rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
            "hide-details": "auto"
          },
          on: {
            change: function change(event) {
              _vm.addressChanged(_objectSpread(_objectSpread({}, event), {}, {
                instanceof: "country"
              }));
              _vm.generateStatesList();
            }
          },
          model: {
            value: _vm.baseModel.country,
            callback: function callback($$v) {
              _vm.$set(_vm.baseModel, "country", $$v);
            },
            expression: "baseModel.country"
          }
        }), _vm.typeDisplayError != "rules" && _vm.errorLabels.country.length > 0 ? _c("p", {
          staticClass: "errorLabel"
        }, [_vm._v(" " + _vm._s(_vm.errorLabels.country) + " ")]) : _vm._e()], 1)];
      }
    }], null, false, 2190911447)
  }, [_c("span", [_vm._v(_vm._s(_vm.countryTooltipMessage))])])] : [_c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.listCountries,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "printable_name",
      "return-object": "",
      label: "Country",
      placeholder: "Country",
      disabled: _vm.disabledCountry || _vm.disabled,
      rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
      "hide-details": "auto"
    },
    on: {
      change: function change(event) {
        _vm.addressChanged(_objectSpread(_objectSpread({}, event), {}, {
          instanceof: "country"
        }));
        _vm.generateStatesList();
      }
    },
    model: {
      value: _vm.baseModel.country,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "country", $$v);
      },
      expression: "baseModel.country"
    }
  }), _vm.typeDisplayError != "rules" && _vm.errorLabels.country.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.country) + " ")]) : _vm._e()], 1)], _vm.displayedListStates.length > 0 ? [_vm.countryTooltipMessage ? [_c(VTooltip, {
    attrs: {
      top: "",
      "max-width": "15rem"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            disabled: _vm.disabledState || _vm.disabled,
            items: _vm.displayedListStates,
            "hide-no-data": "",
            "hide-selected": "",
            "item-text": "state_label",
            "return-object": "",
            label: "State",
            placeholder: "State",
            rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
            "hide-details": "auto"
          },
          on: {
            change: _vm.addressChanged
          },
          model: {
            value: _vm.baseModel.state,
            callback: function callback($$v) {
              _vm.$set(_vm.baseModel, "state", $$v);
            },
            expression: "baseModel.state"
          }
        }), _vm.typeDisplayError != "rules" && _vm.errorLabels.state.length > 0 ? _c("p", {
          staticClass: "errorLabel"
        }, [_vm._v(" " + _vm._s(_vm.errorLabels.state) + " ")]) : _vm._e()], 1)];
      }
    }], null, false, 1324446399)
  }, [_c("span", [_vm._v(_vm._s(_vm.stateTooltipMessage))])])] : [_c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      disabled: _vm.disabledState || _vm.disabled,
      items: _vm.displayedListStates,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "state_label",
      "return-object": "",
      label: "State",
      placeholder: "State",
      rules: _vm.typeDisplayError === "rules" ? [_vm.formRules.mustNotBeEmpty] : [],
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.state,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "state", $$v);
      },
      expression: "baseModel.state"
    }
  }), _vm.typeDisplayError != "rules" && _vm.errorLabels.state.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.state) + " ")]) : _vm._e()], 1)]] : _vm._e(), _vm.showDeliveryInstructions ? _c("div", [_c(VTextarea, {
    attrs: {
      label: "Delivery instructions",
      rows: "3",
      "hide-details": "auto"
    },
    on: {
      change: _vm.addressChanged
    },
    model: {
      value: _vm.baseModel.deliveryInstructions,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "deliveryInstructions", $$v);
      },
      expression: "baseModel.deliveryInstructions"
    }
  })], 1) : _vm._e()], 2)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };